import React from "react";
import styles from "./Button.module.less";
import { Link } from "react-router-dom";

export interface Props {
    className?: string;
    children: string;
    to?: string;
    onClick?: () => void;
    theme?: "white" | "grey";
    small?: boolean;
}

export default function Button(props: Props) {
    if (props.onClick && !props.to) {
        return (
            <button
                {...props}
                className={[
                    styles.Button,
                    styles[("Button--" + props.theme) as keyof typeof styles],
                    props.small ? styles["Button--small"] : null,
                    props.className
                ].join(" ")}
                onClick={props.onClick}
            >
                {props.children}
            </button>
        );
    }

    return (
        <Link
            className={[
                styles.Button,
                styles[("Button--" + props.theme) as keyof typeof styles],
                props.small ? styles["Button--small"] : null,
                props.className
            ].join(" ")}
            to={props.to ?? ""}
            onClick={props.onClick}
        >
            {props.children}
        </Link>
    );
}
